import eps_spire from './assets/eps_spire.png';

export default {
  spire: {
    brand: 'spire',
    logo: eps_spire
  },
}